import { TerminalNames } from '@shared/constants/terminal-names.enum';
import { PAYMENT_METHOD_NAMES } from '@shared/constants';
import { AdyenTerminalInfo } from '@core/services/system/adyen/classes';
import { IActiveTerminal } from '@shared/interfaces';

export const softPOsTerminalHelper = (terminal: AdyenTerminalInfo): IActiveTerminal => {
  return {
    connected: true,
    name: TerminalNames.SOFTPOS,
    title: PAYMENT_METHOD_NAMES.PAYMASH_PAY,
    tipAllowed: false,
    ...terminal,
  }
}
